import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import GoldOutlinedSvg from "@ant-design/icons-svg/es/asn/GoldOutlined";
import AntdIcon from "../components/AntdIcon";
var GoldOutlined = function GoldOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: GoldOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  GoldOutlined.displayName = 'GoldOutlined';
}
export default /*#__PURE__*/React.forwardRef(GoldOutlined);